import { useEffect, useState } from 'react'
import { Exchange } from '../proto/generated/common'
import { ExchangeTradingSession } from '../proto/generated/trading-calendar'
import { getFutureTradingSessionBoundaries, isWithinChartLiveTradingHours } from '../util/tradingSessionLive'

/**
 * Whether the exchange is in a streaming session window now, recomputed on session boundaries
 * (aligned with market status / trading calendar data).
 */
export function useExchangeLiveTradingWindow(
    exchangeTradingSessions: ExchangeTradingSession[] | undefined,
    exchange: Exchange | undefined
): boolean {
    const [live, setLive] = useState(false)
    const [boundaryTick, setBoundaryTick] = useState(0)

    useEffect(() => {
        if (!exchangeTradingSessions?.length || exchange === undefined) {
            setLive(false)
            return
        }

        const recompute = () => {
            setLive(isWithinChartLiveTradingHours(exchangeTradingSessions, exchange))
        }

        recompute()

        const now = Date.now()
        const timeouts: ReturnType<typeof setTimeout>[] = []
        for (const boundary of getFutureTradingSessionBoundaries(exchangeTradingSessions, exchange, now)) {
            const delay = boundary - now
            if (delay > 0) {
                timeouts.push(
                    setTimeout(() => {
                        recompute()
                        setBoundaryTick((t) => t + 1)
                    }, delay)
                )
            }
        }

        const interval = setInterval(recompute, 60_000)

        return () => {
            timeouts.forEach(clearTimeout)
            clearInterval(interval)
        }
    }, [exchangeTradingSessions, exchange, boundaryTick])

    return live
}
